import { getSession } from 'utility/Session'
import { STORE_MENU_LIST, STORE_MENU_TREE } from './action'

const initialState = {
  menu_list: getSession('ago-menu-list'),
  menu_tree: getSession('ago-menu-tree'),
}

export default function menuReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_MENU_LIST:
      return {
        ...state,
        menu_list: action.data,
      }
    case STORE_MENU_TREE:
      return {
        ...state,
        menu_tree: action.data,
      }
    default:
      return state
  }
}
